import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import {
  ShipmentRepository,
  type GetAgnosticShipmentsListParams,
} from '../infra/ShipmentRepository'

export type GetAgnosticShipmentsListFactoryDependencies = {
  repository: ShipmentRepository
}

export function getAgnosticShipmentsListFactory({
  repository,
}: GetAgnosticShipmentsListFactoryDependencies) {
  return async function getAgnosticShipmentsListImpl(
    params: GetAgnosticShipmentsListParams,
    enableNewShipmentsEndpoint: boolean
  ) {
    try {
      return await repository.getAgnosticShipmentsList(params, enableNewShipmentsEndpoint)
    } catch (error) {
      throw new Error(`Failed to get shipments list`, { cause: error as Error })
    }
  }
}

export function getAgnosticShipmentsList(
  params: GetAgnosticShipmentsListParams,
  enableNewShipmentsEndpoint: boolean
) {
  let httpClient

  if (enableNewShipmentsEndpoint) {
    httpClient = createAgnosticHttpClient()
  } else {
    httpClient = new HttpClient(API_URL)
  }

  const repository = new ShipmentRepository({ httpClient })
  const getAgnosticShipments = getAgnosticShipmentsListFactory({ repository })

  return getAgnosticShipments(params, enableNewShipmentsEndpoint)
}
